import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { ComplianceFurthestBehind } from "@/features/compliance/components/compliance-furthest-behind"
import { ComplianceGaps } from "@/features/compliance/components/compliance-gaps"
import { ComplianceStanding } from "@/features/compliance/components/compliance-standing"
import { ComplianceTrend } from "@/features/compliance/components/compliance-trend"
import { complianceQueries } from "@/queries/compliance"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/compliance/"
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(complianceQueries.show()),
  component: CompliancePage,
})

function CompliancePage() {
  return (
    <>
      <PageHeader title="Compliance" />
      <div className="flex flex-col gap-10">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
          <ComplianceStanding />
          <ComplianceTrend />
        </div>
        <ComplianceGaps />
        <ComplianceFurthestBehind />
      </div>
    </>
  )
}
